import { useState } from 'react'

export const HomeState = () => {
    const [total, setTotal] = useState({article: [], posted: [],  saved: []})
    
  return {
    total: {data: total, set: setTotal}
    
  }
}
